import './index.css'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { Button } from './components/button.theme'
import { flexTheme } from './components/flex.theme'
import { Input } from './components/input'

import { Checkbox } from './components/checkbox.theme'
import { formLabelTheme } from './components/formLabel.theme'
import { headingTheme } from './components/heading.theme'
import { radioTheme } from './components/radio.theme'
import { Select } from './components/select.theme'
import { switchTheme } from './components/switch.theme'
import { textTheme } from './components/text.theme'
import { Textarea } from './components/textarea.theme'
import { appColors } from './foundations/colors'
import { spaces } from './foundations/spaces'
import { textStyles } from './foundations/text_styles'

const theme = extendTheme({
  colors: appColors,
  spaces,
  textStyles,
  fonts: {
    heading: `'Parabole', 'Poppins', sans-serif`,
    body: `'Parabole', 'Poppins', sans-serif`,
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '976px',
    lg: '1440px',
    xl: '2560px',
  },
  components: {
    Button,
    Input,
    Flex: flexTheme,
    Select,
    FormLabel: formLabelTheme,
    Form: {
      baseStyle: {
        requiredIndicator: {
          color: '#4D4D4D',
        },
      },
    },
    Textarea,
    Checkbox,
    Heading: headingTheme,
    Switch: switchTheme,
    Text: textTheme,
    Radio: radioTheme,
  },
})

export const ThemeProvider = ({ children }) => {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>
}

export { appColors } from './foundations/colors'
export { theme as chakraTheme }
